import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import { baseStyles, typographyStyles } from '@/styles';

@customElement('fg-translation-wrapper')
@localized()
export class FgTranslationWrapper extends LitElement {
  @property({ type: String })
  translationKey?: string;

  render() {
    if (!this.translationKey) {
      return nothing;
    }
    return html`
      ${unsafeHTML(
        t(this.translationKey, {
          html: '<slot name="inner-html"></slot>',
          interpolation: {
            escapeValue: false,
          },
        }),
      )}
    `;
  }
  static styles = [baseStyles, typographyStyles];
}
